
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { DepartmentItemProps } from ".";
import { loading, find } from "store/department";

interface ApiDepartmentFindByIdInputProps {
    id: number;
}

type ApiDepartmentFindOutputProps = OutputBaseProps<{ item: DepartmentItemProps; }, DepartmentItemProps>;

export const apiDepartmentFindById = async (data: ApiDepartmentFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiDepartmentFindOutputProps>(`/api/department/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};
